import { Injectable } from '@angular/core';
import { AddressyRetrieveApiService } from './api/addressy-retrieve-api.service';
import { AddressyFindApiService } from './api/addressy-find-api.service';
import {
  AddressyItemType,
  BaseAddressyItem
} from '../../interfaces/addressy/api/address/find-api.interface';
import { Observable, switchMap } from 'rxjs';
import { AddressyResponse } from '../../interfaces/addressy/api/addressy-api.interface';
import { AddressyItem } from '../../interfaces/addressy/api/address/retrieve-api.interface';

@Injectable({ providedIn: 'root' })
export class AddressyService {
  constructor(
    private addressyFindApiService: AddressyFindApiService,
    private addressyRetrieveApiService: AddressyRetrieveApiService
  ) {}

  getAddressDetails(
    id: string,
    text: string,
    type: AddressyItemType
  ): Observable<AddressyResponse<AddressyItem[]>> {
    if (type === AddressyItemType.Address) {
      return this.addressyRetrieveApiService.getAddressById(id);
    }

    const parameters = { containerId: id, searchText: text };
    return this.addressyFindApiService.getAddresses(parameters).pipe(
      switchMap((response: AddressyResponse<BaseAddressyItem[]>) => {
        const addressId: string = response.Items[0].Id;
        return this.addressyRetrieveApiService.getAddressById(addressId);
      })
    );
  }
}
